import React from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { colors, Ellipsis, H3, Paragraph, LabelTooltip, SelectableCard } from '@fs/zion-ui'
import { NoticeWarning } from '@fs/zion-icon'

const warningIconCSS = css`
  position: absolute;
  top: 4%;
  inset-inline-start: 79%;
`

const StoryCard = ({ story, isSelected, onSelect, maxTitleCount, maxTextCount }) => {
  const [t] = useTranslation()
  const isTitleOverLimit = story.title?.length > maxTitleCount
  const isTextOverLimit = story.fullText?.length > maxTextCount
  const hasWarning = isTitleOverLimit || isTextOverLimit

  return (
    <SelectableCard minHeight={250} checked={isSelected} onClick={() => onSelect(story)}>
      {hasWarning && (
        <div css={warningIconCSS} data-testid="warning-icon">
          <LabelTooltip
            label={t('GalleryStories.storyWarning.description', 'The title or story exceeds the allowed length.')}
            placement="top"
            target={<NoticeWarning size="sm" color={colors.yellow50} />}
          />
        </div>
      )}
      <H3 size="H5">{story.title}</H3>
      <Paragraph size="sm">
        <Ellipsis lineClamp={5} noTooltip>
          {story.description}
        </Ellipsis>
      </Paragraph>
    </SelectableCard>
  )
}

export default StoryCard
